"use strict";

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass.js");
var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits.js");
var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
var _wrapNativeSuper = require("/opt/build/repo/node_modules/@babel/runtime/helpers/wrapNativeSuper.js");
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EExternalActionConnectionStatus = exports.EMeteorWalletExternalActionSource = exports.EWalletExternalActionStatus = exports.EWalletExternalAction_SignIn_AccessType = exports.EMeteorWalletSignInType = exports.EWalletExternalActionType = exports.MeteorActionError = void 0;
var ExternalActionErrorMessages_1 = require("./ExternalActionErrorMessages");
var MeteorActionError = /*#__PURE__*/function (_Error) {
  _inherits(MeteorActionError, _Error);
  var _super = _createSuper(MeteorActionError);
  function MeteorActionError(reason, previousError) {
    var _this;
    _classCallCheck(this, MeteorActionError);
    var _a, _b;
    _this = _super.call(this);
    if (reason.message == null) {
      reason.message = (0, ExternalActionErrorMessages_1.getExternalActionErrorMessageForEndTag)((_b = (_a = reason.endTags) === null || _a === void 0 ? void 0 : _a[reason.endTags.length - 1]) !== null && _b !== void 0 ? _b : "unknown");
    }
    _this._reason = reason;
    _this.message = reason.message;
    _this.name = "MeteorActionError";
    _this.cause = previousError;
    return _this;
  }
  return _createClass(MeteorActionError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
exports.MeteorActionError = MeteorActionError;
var EWalletExternalActionType;
(function (EWalletExternalActionType) {
  EWalletExternalActionType["login"] = "login";
  EWalletExternalActionType["sign"] = "sign";
  EWalletExternalActionType["logout"] = "logout";
  EWalletExternalActionType["verify_owner"] = "verify_owner";
})(EWalletExternalActionType = exports.EWalletExternalActionType || (exports.EWalletExternalActionType = {}));
var EMeteorWalletSignInType;
(function (EMeteorWalletSignInType) {
  EMeteorWalletSignInType["ALL_METHODS"] = "ALL_METHODS";
  EMeteorWalletSignInType["SELECTED_METHODS"] = "SELECTED_METHODS";
  EMeteorWalletSignInType["FULL_ACCESS"] = "FULL_ACCESS";
})(EMeteorWalletSignInType = exports.EMeteorWalletSignInType || (exports.EMeteorWalletSignInType = {}));
var EWalletExternalAction_SignIn_AccessType;
(function (EWalletExternalAction_SignIn_AccessType) {
  EWalletExternalAction_SignIn_AccessType["FULL_ACCESS"] = "fullAccess";
  EWalletExternalAction_SignIn_AccessType["LIMITED_ACCESS"] = "limitedAccess";
})(EWalletExternalAction_SignIn_AccessType = exports.EWalletExternalAction_SignIn_AccessType || (exports.EWalletExternalAction_SignIn_AccessType = {}));
var EWalletExternalActionStatus;
(function (EWalletExternalActionStatus) {
  EWalletExternalActionStatus["UNCONFIRMED"] = "UNCONFIRMED";
  EWalletExternalActionStatus["PENDING"] = "PENDING";
  EWalletExternalActionStatus["SUCCESS"] = "SUCCESS";
  EWalletExternalActionStatus["FAILURE"] = "FAILURE";
})(EWalletExternalActionStatus = exports.EWalletExternalActionStatus || (exports.EWalletExternalActionStatus = {}));
var EMeteorWalletExternalActionSource;
(function (EMeteorWalletExternalActionSource) {
  EMeteorWalletExternalActionSource["website_callback"] = "wcb";
  EMeteorWalletExternalActionSource["website_post_message"] = "wpm";
  EMeteorWalletExternalActionSource["extension_injected"] = "ext";
})(EMeteorWalletExternalActionSource = exports.EMeteorWalletExternalActionSource || (exports.EMeteorWalletExternalActionSource = {}));
var EExternalActionConnectionStatus;
(function (EExternalActionConnectionStatus) {
  EExternalActionConnectionStatus["initializing"] = "initializing";
  EExternalActionConnectionStatus["connected"] = "connected";
  EExternalActionConnectionStatus["attempting_reconnect"] = "attempting_reconnect";
  EExternalActionConnectionStatus["disconnected"] = "disconnected";
  EExternalActionConnectionStatus["closed_success"] = "closed_success";
  EExternalActionConnectionStatus["closed_fail"] = "closed_fail";
  EExternalActionConnectionStatus["closed_window"] = "closed_window";
})(EExternalActionConnectionStatus = exports.EExternalActionConnectionStatus || (exports.EExternalActionConnectionStatus = {}));